import React from 'react';
import './User.css';

// Components
import EditUser from '../../../../components/User/EditUser';
import ProfilePhoto from '../../../../components/User/ProfilePhoto';
import UserSubscriptionAdminPanel from '../../../../components/User/UserSubscriptionAdminPanel';
import UserSearchBar, {
    EMPTY_USER_FILTER,
    getUserFilterSearchParams,
} from '../../../../components/Users/Search';

import { getUser } from '../../../../utils/firebase/getUser';
import { handleUpdate } from '../../../../utils/firebase/updateUser';
import { trackEvent } from '../../../../utils/ga';
import useUserProfileStore from '../../../../stores/userProfileStore';
import { useNavigate, useParams } from 'react-router-dom';
import { hasSettingsAccess, SETTINGS_SECTION_KEYS } from '../../../../utils/accessControl';

export default function User() {
    const userDoc = useUserProfileStore(state => state.userDoc);
    const setUserDoc = useUserProfileStore(set => set.setUserDoc);
    const role = useUserProfileStore(state => state.role);
    const [loading, setLoading] = React.useState(true);
    const [filter, setFilter] = React.useState(() => ({ ...EMPTY_USER_FILTER }));
    const { userId = '' } = useParams();
    const navigate = useNavigate();
    const canViewSubscriptionBilling = hasSettingsAccess(role, SETTINGS_SECTION_KEYS.ADMIN_TOOLS);


    const assignUser = React.useCallback(async () => {
        try {
            const userDocData = await getUser(userId);
            setUserDoc(userDocData.userDocData);
            console.log('userDocdat', userDocData.userDocData);
            setLoading(userDocData.loaded);
        } catch (error) {
            alert(error?.message || 'Unable to load this user.');
            setLoading(false);
        }
    }, [setUserDoc, userId]);

    React.useEffect(() => {
        assignUser();
    }, [assignUser]);

    const handleSaveChanges = async () => {
        try {
            await handleUpdate(userDoc);
            await assignUser();
            trackEvent('user', 'update');
        } catch (error) {
            console.error('Error saving user changes:', error);
        }
    };

    const handleFilterChange = (event) => {
        setFilter((currentFilter) => ({
            ...currentFilter,
            [event.target.name]: event.target.value,
        }));
    };

    const handleUserSearch = (event) => {
        event.preventDefault();
        const nextSearchParams = getUserFilterSearchParams(filter);

        if (Object.keys(nextSearchParams).length === 0) {
            alert('Please enter a filter');
            return;
        }

        const search = new URLSearchParams(nextSearchParams).toString();
        navigate(`/users${search ? `?${search}` : ''}`);
    };

    return (
        <>
            <div className='user__container'>
                <div className='user__search'>
                    <UserSearchBar
                        filter={filter}
                        onFilterChange={handleFilterChange}
                        onSubmit={handleUserSearch}
                    />
                </div>
                <div className='user__heading'>
                    Edit
                </div>
                {/* save changes button */}
                <button className='user__button'
                    onClick={handleSaveChanges}
                >Save Changes</button>


                {!loading && <>

                    <ProfilePhoto />
                    <EditUser />
                    {canViewSubscriptionBilling && <UserSubscriptionAdminPanel userId={userId} />}

                </>}
            </div>
        </>

    );
}
